import {
  HARVEST_YIELD_COMPARISON_REPORT_CODE,
  harvestYieldComparisonConfig,
  getHarvestYieldComparisonRowStatus,
  buildHarvestYieldComparisonSummaryCards,
  buildHarvestYieldComparisonRowLegendItems,
} from "./reports/harvestYieldComparison";

export const REPORT_CODE_CONFIGS = {
  [HARVEST_YIELD_COMPARISON_REPORT_CODE]: harvestYieldComparisonConfig,
};

const REPORT_ROW_STATUS_RESOLVERS = {
  [HARVEST_YIELD_COMPARISON_REPORT_CODE]: getHarvestYieldComparisonRowStatus,
};

const REPORT_SUMMARY_BUILDERS = {
  [HARVEST_YIELD_COMPARISON_REPORT_CODE]: buildHarvestYieldComparisonSummaryCards,
};

const REPORT_ROW_LEGEND_BUILDERS = {
  [HARVEST_YIELD_COMPARISON_REPORT_CODE]: buildHarvestYieldComparisonRowLegendItems,
};

const REPORT_STYLE_LOADERS = {
  [HARVEST_YIELD_COMPARISON_REPORT_CODE]: () => import("./styles/harvestYieldComparison.scss"),
};

const loadedReportStyles = new Set();

export function getRowStatusByReportCode(reportCode, row, context) {
  const resolver = REPORT_ROW_STATUS_RESOLVERS[reportCode];
  return resolver ? resolver(row, context) : null;
}

export function buildSummaryCardsByReportCode(reportCode, context) {
  const builder = REPORT_SUMMARY_BUILDERS[reportCode];
  return builder ? builder(context) : [];
}

export function buildRowLegendItemsByReportCode(reportCode, context) {
  const builder = REPORT_ROW_LEGEND_BUILDERS[reportCode];
  return builder ? builder(context) : [];
}

export function ensureReportStylesLoaded(reportCode) {
  if (!reportCode) {
    return Promise.resolve();
  }

  if (loadedReportStyles.has(reportCode)) {
    return Promise.resolve();
  }

  const loader = REPORT_STYLE_LOADERS[reportCode];
  if (!loader) {
    return Promise.resolve();
  }

  loadedReportStyles.add(reportCode);
  return loader().catch((error) => {
    loadedReportStyles.delete(reportCode);
    throw error;
  });
}